import { P2GContainer } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

export const RouteAppWrapper = ({
  isXs,
  children,
  maxWidth
}: {
  isXs: boolean;
  children: ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}) => {
  return isXs ? children : <P2GContainer maxWidth={maxWidth ?? 'md'}>{children}</P2GContainer>;
};
